import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";
import b10bg from "@/assets/images/b10Backgound.webp";

export const PushMailWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.md ? "1/-1" : "2/16",
  maxWidth: theme?.breakpoints?.md ? "100%" : "979px",
  marginInline: theme?.breakpoints?.md ? 0 : 20,
  display: "flex",
  flexDirection: theme?.breakpoints?.isMobile ? "column" : "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBlock: 30,
  backgroundImage: `url("${b10bg}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  padding: theme?.breakpoints?.isMobile ? "0px 16px 10px 16px" : "40px 32px 40px 80px",
  borderRadius: 26,
  boxShadow: "0px 0px 32px 0px rgb(0 0 0 / 8%)",
}));

export const PushMailImage = styled.img<{credit?: string}>(({theme, credit}) => ({
  position: "relative",
  width: "100%",
  alignSelf: "center",
  height: theme?.breakpoints?.isMobile ? 96 : 160,
  maxWidth: theme?.breakpoints?.isMobile ? 96 : 160,
  marginRight: theme?.breakpoints?.isMobile ? 0 : theme?.breakpoints?.md ? 100 : 177,
  padding: theme?.breakpoints?.isMobile ? "24px 0" : "12px 0",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: theme?.breakpoints?.isMobile ? "right" : "bottom",
  ":before": {
    content: `"${credit}"`,
    position: "absolute",
    bottom: 5,
    left: 0,
    width: "100%",
    height: "auto",
    color: theme?.colors?.primaryGrey,
    borderRadius: 4,
    fontSize: "0.75rem",
    lineHeight: 1,
    fontWeight: 400,
    fontFamily: theme?.font?.manrope,
  },
}));

export const ContentWrapper = styled.div(
  (): CSSObject => ({
    marginBottom: 30,
    display: "flex",
    flexDirection: "column",
    width: "100%",
  }),
);

export const TitleWrapper = styled.div(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 17,
  }),
);

export const PushMailPictogramme = styled.img(() => ({
  width: 30,
  height: 30,
  marginRight: 10,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
}));

export const PushMailTitle = styled.div(({theme}) => ({
  fontSize: "0.75rem",
  lineHeight: 1,
  fontWeight: 700,
  fontFamily: theme?.font?.manrope,
  textTransform: "uppercase",
  letterSpacing: "0.02em",
}));

export const PushMailText = styled.div(({theme}) => ({
  marginBottom: 17,
  fontSize: theme?.breakpoints?.isMobile ? "1.125rem" : "1.25rem",
  lineHeight: theme?.breakpoints?.isMobile ? 1.3 : 1.4,
  fontWeight: 400,
  fontFamily: theme?.font?.manrope,
}));
